<template>
  <div class="transfer wrap">
    <PayHead :mainTitle="currency_short == '' ? '' : ('' + currency_short + '') + ' '+pc_lang.Fund_Transfer"/>
    <div class="wrapContent">

      <div v-show="finish == 0">
        <p class="notice">ⓘ{{pc_lang.Tips_System_automatically_notify_the_payee_of_the_transfer_result}}</p>
        <!-- 表单信息 -->
        <el-form :model="transferForm" :rules="rulesForm" ref="transferForm" label-width="0" class="transferForm">
          <el-form-item prop="transferWay">
            <p>{{pc_lang.Payee_phone_Number__Email_Address}}</p>
            <el-input v-model="transferForm.transferWay" prefix-icon="el-icon-mobile-phone" autocomplete="off" :placeholder="pc_lang.Please_enter_your_mobile_number__email_address" size="medium"></el-input>
          </el-form-item>
          <el-form-item prop="amount">
            <p>{{pc_lang.Transfer_amount}} <span class="tips">{{pc_lang.Credit_Balance}}：{{balanceItem.currency_short}} {{balance}}</span></p>
            <el-input v-model="transferForm.amount" prefix-icon="el-icon-money" autocomplete="off" :placeholder="pc_lang.Please_enter_the_transfer_amount" size="medium"></el-input>
          </el-form-item>
          <el-form-item prop="payPassword">
            <p>{{pc_lang.Payment_password}}</p>
            <el-input type="password" v-model="transferForm.payPassword" prefix-icon="el-icon-lock" autocomplete="off" :placeholder="pc_lang.Please_enter_the_payment_password" size="medium"></el-input>
          </el-form-item>
          <el-form-item prop="tradeNotes">
            <p>{{pc_lang.Transfer_remark}}</p>
            <el-input v-model="transferForm.tradeNotes" prefix-icon="el-icon-notebook-2" autocomplete="off" :placeholder="pc_lang.Please_enter_a_transfer_remark" size="medium"></el-input>
          </el-form-item>
        </el-form>
        <div class="submit">
          <p>我已阅读并同意 <span>《转账条款》</span></p>
          <el-button type="primary" size="medium" class="nextStep" @click="regForm('transferForm')">{{pc_lang.Confirm_transferred}}</el-button>
        </div>

        <!-- FAQ -->
        <div class="FAQ" v-if="FAQ.transfer">
          <h5>FAQ</h5>
          <template v-for="(item, i) in FAQ.transfer">
            <div>{{item.title}}</div>
            <p>{{item.content}}</p>
          </template>
        </div>
      </div>

      <div v-show="finish == 1">
        <Finish
        v-if="finish == 1"
        :mainTitle="pc_lang.Submitted_successfully"
        :descWord="pc_lang.Successful_transfered_about_to_enter_the_Fortune_Center_page"
        :routeA="'/riches'"
        :routeWordA="pc_lang.My_Credit"
        :routeB="'fresh'"
        :routeWordB="pc_lang.Continue_to_transfer"
        :btnBool="true"
        :countBool="true"
        ></Finish>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'
import * as API_PAY from '@/api/pay'
import * as RegExp from '@/utils/RegExp'

import PayHead from '@/components/PayHead'
import Finish from '@/components/ui/Finish'

export default {
  name: 'Transfer',
  components: {
    PayHead,
    Finish
  },
  computed: {
    ...mapGetters(['FAQ'])
  },
  data() {
    // 金额验证
    var validateMoney = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.pc_lang.Please_enter_the_transfer_amount));
      } else if (!RegExp.money.test(value)) {
        callback(new Error(this.pc_lang.Please_enter_the_correct_transfer_amount));
      } else if (Number(value) > Number(this.balance)) {
        callback(new Error(this.pc_lang.Your_account_does_not_have_sufficient_balance));
      } else {
        callback();
      }
    };
    // 验证密码格式
    var validatePassWord = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.pc_lang.Enter_the_password));
      } else if( !RegExp.payword.test(value) ) {
        callback(new Error(this.pc_lang.Password_consists_of_6_digits));
      }else {
        callback();
      }
    };
    // 收款人手机/邮箱验证
    var regTransferMember = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.pc_lang.Please_enter_the_payee_phone_number__email_addres));
      } else {
        let param = {
          transferWay: value
        }
        this.regTransferWay(param).then(res=> {
          callback();
        },rej=> {
          callback(new Error(this.pc_lang.Please_enter_the_correct_payee_mobile_number__email_address));
        })
      }
    };
    return {
      /* 是否转账成功 */
      finish: 0,
      /* 最近转账记录 */
      lastTransfer: [],
      /* 当前转账币种 */
      currency_short: this.$route.query.currency_short,
      // 表单
      transferForm: {
        /* 币种 */
        currencyShort: this.$route.query.currency_short,

        /* 转账金额 */
        amount: '',

        /* 转账密码 */
        payPassword : '',

        /* 邮箱/手机号 */
        transferWay: '',

        /* 收款人姓名 */
        // transferUsername: '',

        /* 转账说明 */
        tradeNotes: '',
      },
      // 表单验证
      rulesForm:{
        amount: [
          { validator: validateMoney, trigger: 'blur' }
        ],
        payPassword: [
          { validator: validatePassWord, trigger: 'blur' }
        ],
        transferWay: [
          { validator: regTransferMember, trigger: 'blur' }
        ]
      },
      //用户余额列表
      balanceList: [],
      //用户余额
      balance: '',
      //用户余额item
      balanceItem: '',
    }
  },
  async mounted() {

  },
  created() {
    this.getLastTransfer()
    this.getUserBalance().then(()=> {
      this.actBalance()
    })
  },
  methods: {
    /* 重置表单 */
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    /* 表单验证 */
    regForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.transferApply().then((res)=>{
            window.scrollTo(0, 0)
            this.finish = 1
          },rej=> {
            this.$messageBox.alert(rej.msg, this.pc_lang.Submission_Failed, {
              confirmButtonText: this.pc_lang.Confirm2
            });
          })
        }else{
          return false
        }
      })
    },
    /* 获取最近转账记录 */
    getLastTransfer() {
      API_PAY.lastTransfer().then(res=> {
        console.log(res)
      })
    },
    /* 获取最近转账记录 */
    regTransferWay(param) {
      return new Promise((resolve, reject)=> {
        API_PAY.regTransferWay(param).then(res=> {
          resolve()
        },rej=> {
          reject(rej)
        })
      })
    },
    /* 提交转账申请 */
    transferApply() {
      return new Promise((resolve, reject)=> {
        let params = JSON.parse(JSON.stringify(this.transferForm))
        params.payPassword = md5(params.payPassword)
        API_PAY.transferApply(params).then(res=> {
          resolve()
        },rej=> {
          reject(rej)
        })
      })
    },
    /* 获取用户余额 */
    getUserBalance() {
      return new Promise((resolve, reject)=> {
        API_PAY.getUserBalance().then(res=>{
          this.balanceList = res.data
          resolve(1)
        },
        rej=>{
          console.log('rej', rej)
          reject(rej)
        })
      })
    },
    /* 获取用户余额 */
    actBalance() {
      this.balanceList.forEach(obj=> {
        if (obj.currency_short == this.$route.query.currency_short ) {
          this.balance = obj.amount
          this.balanceItem = obj
        }
      })

      if (this.balance == '') {
        this.$messageBox.alert(this.pc_lang.This_account_has_insufficient_balance_to_transfer_please_choose_an_account_with_a_balance_thank_you, this.$route.query.currency_short + '转账失败',  {
          confirmButtonText: this.pc_lang.Confirm2,
          callback: ()=>{
            this.$router.push({name: 'Riches'})
          }
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.wrapContent{
  margin: 20px auto;
  background: #fff;
  padding: 20px 40px;
  .notice{
    color: #666;
    margin: 0 0 20px;
  }
  .tips{
    font-size: 12px;
    color: #999;
    margin-left: 12px;
  }
  .el-input,.el-select{
    width: 450px;
  }
  .el-form-item{
    margin-bottom: 14px;
  }
  .submit{
    padding-bottom: 20px;
    p{
      padding: 20px 0;
      font-size: 12px;
      span{
        color: #007DD1;
        cursor: pointer;
      }
    }
  }
}
</style>